import Vue from "vue";
import Vuex from "vuex";
import ui from "./modules/ui";
import app from "./modules/app";
import auth from "@/modules/auth/vuex";
import shop from "@/modules/shop/vuex";
import createLogger from "@/util/plugins/logger";

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";
Vue.config.debug = debug;

export default new Vuex.Store({
  modules: {
    ui,
    app,
    auth,
    shop
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
});
